export enum UserRoleFilterOptions {
    None = 1,
    DeletedRoles = 2
}
